import Icon from '../components/Icon.vue'

Icon.register({"star-half-full":{"width":1664,"height":1792,"paths":[{"d":"M1186 957l257-250-356-52-66-10-30-60-159-322v963l59 31 318 168-60-355-12-66zM1638 695l-363 354 86 500q5 33-6 51.5t-34 18.5q-17 0-40-12l-449-236-449 236q-23 12-40 12-23 0-34-18.5t-6-51.5l86-500-364-354q-32-32-23-59.5t54-34.5l502-73 225-455q20-41 49-41 28 0 49 41l225 455 502 73q45 7 54 34.5t-24 59.5z"}]}})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/star-half-full.js
// module id = y3fd
// module chunks = 1